/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicModule
 */
export interface PublicModule {
    /**
     * 
     * @type {boolean}
     * @memberof PublicModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the PublicModule interface.
 */
export function instanceOfPublicModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicModuleFromJSON(json: any): PublicModule {
    return PublicModuleFromJSONTyped(json, false);
}

export function PublicModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function PublicModuleToJSON(value?: PublicModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

